"use client";

import { useState } from "react";
import dynamic from "next/dist/shared/lib/dynamic";
import { PropertyTypeV2, StructuredDescriptionType } from "commonModule/services/common";
import NewHomeIcon from "components/icons-svg/NewhomeIcon";
import CVAModal from "components/modals/common/CVAModal";
import Divider from "components/utilities/Divider";
import { DURKIN_COTTAGES_PMC_ID, ELITE_PACIFIC_PMC_ID } from "constant";
import { useDisclosure } from "utils/hooks/useDisclosure";
const ElitepacificTermsAndConditions = dynamic(() => import( /* webpackChunkName: "ElitepacificTermsAndConditions" */"./terms/ElitepacificTermsAndConditions"), {
  ssr: false
});
const DurkinCottagesTermsAndConditions = dynamic(() => import( /* webpackChunkName: "DurkinCottagesTermsAndConditions" */"./terms/DurkinCottagesTermsAndConditions"), {
  ssr: false
});
const PropertyDescriptionSection = ({
  property,
  structuredDescription
}: {
  property: PropertyTypeV2;
  structuredDescription?: StructuredDescriptionType | null;
}) => {
  const {
    isOpen: isTermsAndConditionOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const description = property.delete ? "This property isn't available right now, but your perfect vacation spot is still out there! Explore other fantastic vacation rentals in this region and find the perfect place for your stay." : structuredDescription?.combined_description?.trim() || property?.property_desc?.trim() || "";
  const [isFullDescVisibe, setIsFullDescVisible] = useState(!(description?.length > 600));
  return <>
      {/* divider */}
      <div className='my-8 hidden h-[1px] bg-grayBorder lg:block' />

      <div className='mb-4 mt-6 flex items-center gap-2 md:mb-6 lg:mt-0'>
        <NewHomeIcon className='h-[16px] w-[17.996px] md:h-[20px] md:w-[22.495px]' data-sentry-element="NewHomeIcon" data-sentry-source-file="PropertyDescriptionSection.tsx" />
        <h2 className='text-base font-semibold leading-[19.2px] tracking-[-0.24px] text-secondary500 md:text-xl md:leading-6 md:tracking-[-0.3px]'>
          About this stay
        </h2>
      </div>
      <div className='scroll-mt-28 bg-white lg4:flex' id='property_description'>
        <div>
          <div className='relative'>
            <div className={`defaultStyleSheet custom-break-word relative whitespace-pre-line text-sm font-normal leading-[23.8px] text-brand-dark md:text-base md:leading-[27.2px] md:text-black-800 min-[1140px]:pr-8 xl:pr-16
             ${isFullDescVisibe ? " line-clamp-none" : " line-clamp-[10] md:line-clamp-5"} [&_li_li]:list-[circle] [&_ol]:whitespace-normal [&_ul]:whitespace-normal`} dangerouslySetInnerHTML={{
            __html: description
          }} />
            {/* Fade effect */}
            {!isFullDescVisibe && <div className='pointer-events-none absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent' />}
          </div>
          {/* Show more button if more content in description  */}
          <div className='mt-4 md:mt-6'>
            {description?.length > 600 && <button id={isFullDescVisibe ? "hide-full-description" : "show-full-description"} type='button' className='h-7 bg-white text-sm font-semibold text-accent-500 underline md:text-base' onClick={() => {
            if (isFullDescVisibe) {
              const element = document?.getElementById("property_description");
              element?.scrollIntoView({
                inline: "start"
              });
            }
            setIsFullDescVisible(x => !x);
          }} {...!isFullDescVisibe ? {
            "data-track-v2-event": "PDP_DESCRIPTION_CLICK",
            "data-track-v2-props": JSON.stringify({
              propertyId: property?.property_id || ""
            })
          } : {}}>
                {isFullDescVisibe ? "Show less" : "Show more"}
              </button>}
            {(property?.pmc_id === ELITE_PACIFIC_PMC_ID || property?.pmc_id === DURKIN_COTTAGES_PMC_ID) && <button id='show-terms-and-conditions' className='ml-[35px] text-sm font-semibold text-secondary500 underline md:text-base' onClick={onOpen}>
                Terms & Condition
              </button>}
          </div>
        </div>

        {/* lazy load this modal , bcoz very low priority to open this modal */}
        {isTermsAndConditionOpen && <CVAModal isOpen={isTermsAndConditionOpen} onClose={onClose} intent={"modal"} size={"medium"} className='h-[calc(100dvh_-_10rem)!important]'>
            <header className='p-4 text-center'>
              <p className='text-xl font-semibold'>Terms & Condition</p>
            </header>
            <Divider />
            <main className='mb-4 overflow-y-scroll p-4 md:p-6'>
              {property?.pmc_id === ELITE_PACIFIC_PMC_ID && <ElitepacificTermsAndConditions />}
              {property?.pmc_id === DURKIN_COTTAGES_PMC_ID && <DurkinCottagesTermsAndConditions />}
            </main>
          </CVAModal>}
      </div>
    </>;
};
export default PropertyDescriptionSection;